import { onMounted, ref, watch, type MaybeRefOrGetter } from 'vue'
import { useDocument } from 'vuefire'
import { type DocumentReference } from 'firebase/firestore'
import { logger as rootLogger, type Logger, type LogContext } from '@/utils/logger.ts'

export function useLiveDocument<T>(
  docRef: MaybeRefOrGetter<DocumentReference<T> | null>,
  opts?: { label?: string; log?: boolean; context?: LogContext },
) {
  const l: Logger = opts?.label
    ? rootLogger.child(`useLiveDocument:${opts.label}`)
    : rootLogger.child('useLiveDocument')
  const t0 = ref(0)
  const first = ref(true)
  const doc = useDocument(docRef)

  onMounted(() => {
    t0.value = performance.now()
  })

  watch(
    doc,
    (v) => {
      const present = !!v
      if (first.value) {
        first.value = false
        if (opts?.log !== false)
          l.info('vuefire.document.loaded', {
            ...opts?.context,
            present,
            durationMs: Math.round(performance.now() - t0.value),
          })
      } else {
        if (opts?.log !== false) l.debug('vuefire.document.updated', { ...opts?.context, present })
      }
    },
    { immediate: true },
  )

  return { doc }
}
